import { useState } from 'react';
import {
  Box, Button, Modal, Typography, Fade,
} from '@mui/material';
import { styles } from '../../assets/styles';
import { About } from '../../data/modalText';

export default function InfoButton() {
  const [isHovering, setIsHovering] = useState(false);

  const handleMouseOver = () => {
    setIsHovering(true);
  };

  const handleMouseOut = () => {
    setIsHovering(false);
  };

  const [open2, setOpen2] = useState(false);

  const handleOpen2 = () => {
    setOpen2(true);
  };

  const handleClose2 = () => {
    setOpen2(false);
  };

  return (
    <>
      <Button
        disableRipple
        className="info-icon-button"
        onMouseOver={handleMouseOver}
        onMouseOut={handleMouseOut}
        onClick={handleOpen2}
        sx={styles.infoIconButton}
      >
        {' '}
        {isHovering && <Box sx={styles.buttonAboutHoverBox}>About</Box>}
      </Button>

      <Modal open={open2} onClose={handleClose2} sx={styles.modalOpen}>
        <Fade in={open2}>
          <Box sx={styles.aboutModalBox}>
            <Box sx={styles.aboutModalBox2}>
              <Box sx={styles.aboutModalBox3}>
                <Typography variant="h4" sx={styles.aboutModalTypography}>
                  About
                </Typography>
                {' '}
                <Typography variant="h6" sx={styles.aboutModalTypographyH6}>
                  {' '}
                  {About.Daily}
                  {' '}
                </Typography>
                <Typography variant="h6" sx={styles.aboutModalTypographyH6}>
                  {About.Content}
                  {' '}
                </Typography>
                {' '}
                <Typography variant="h6" sx={styles.aboutModalTypographyH6}>
                  {About.Project}
                  {' '}
                  <a
                    href="https://loldle.net"
                    target="_blank"
                    rel="noreferrer"
                    style={styles.modalHref}
                  >
                    <span style={styles.modalColor1}>Loldle</span>
                    ,
                  </a>
                  {' '}
                  go check it out!
                </Typography>
                <Typography variant="h6" sx={styles.aboutModalTypographyH6}>
                  {About.Questions}
                  {' '}
                  <span style={styles.modalColor2}>{About.Mail}</span>
                  {' '}
                </Typography>
                <Typography variant="h6" sx={styles.aboutModalTypographySmall}>
                  {About.End}
                  {' '}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Fade>
      </Modal>
    </>
  );
}
